export default {
  global: {
    title: "Calculateur d'irrigation",
    cancel: "cancel",
    close: "fermer",
    create: "create",
    back: `Précédant`,
    next: `Suivant`,
    ok: "Ok",
    confirm: "confirmer",
  },
  home: {
    title: "Bienvenue",
    description:
      "Le calculateur d`irrigation est un outil de planification pour la mise en place d`équipement d`irrigation au champ.",
    link: "Allez au calculateur d`irrigation",
  },
  walktrough: [
    {
      step: `addWaterSource`,
      text: `Il faut d'abord ajouter la source d'eau.`,
      icon: `mdi-map-marker`
    },
    {
      step: `defineWaterSourcePath`,
      text: `Il faut ensuite tracer le chemin de l'alimentation de la source d'eau.`,
    },
    {
      step: `drawIrrigationArea`,
      text: `Finalement, il faut définir la zone d'irrigation.`,
    }
  ],
  calculator: {
    form: {
      step1Title: `Définir la zone d'irrigation`,
      warning:
        "** L`orientation des champs, des pentes, du soleil sont relatifs au nord.**",
      fieldLength: "Longueur du champ (m)",
      fieldWidth: "Largeur du champ (m)",
      fieldOrientation: "Orientation du champ (deg)",
      bedsSpacing: "Espacement entre les lits (m)",
      cropSpacing: "Espacement entre les rangés par lit (m)",
      distWaterSource: "Distance entre la source d`eau et le champ (m)",
      slopeOrientation: "Orientation de la pente du champ (deg)",
      solarOrientation: "Orientation solaire (deg)",
      soilTypeLabel: "Types de sol",
      soilTypes: ["Argileux", "Limoneux", "Sabloneux", "Rocailleux"],
      cropTypeLabel: "Type de culture",
      cropTypes: [
        "Maraicher conventionnel",
        "Fruitier",
        "Maraicher bio intensif",
      ],
      irrigationTypesLabel: "Type de système d`irrigation",
      irrigationTypes: [
        "irrigation goutte à goutte",
        "irrigation par aspersion",
      ],
      plantingMethod: "Méthode de plantation",
      waterConsumption: "Consommation d`eau par semaine (l/sem)",
      step2Title: `Définir le système d'irrigation`,
      waterSourceTypeLabel: `Approvisionnement en eau`,
      waterSourceTypes: [
        `Bassin`,
        `Eau stagnante`,
        `Veines souteraines`,
        `lac`,
        `eau renouvellée`,
        `Pompe d'un puit`,
        `Approvisionnement municipal`,
      ],
      waterSourcePipeDiameter: `Diamètre du tuyan d'alimentation (pc)`,
      minimalPressure: `Pression minimal (p.s.i)`,
      maximumPressure: `Pression maximale (p.s.i)`,
      doYouHaveAPump: `Posssez-vous une pompe ?`,
      pumpModel: `Quel est le modèle de notre pompe ?`,
      pumpPreference: `Prérérez-vous une pompe électique ou à essence ?`,
      pumpPreferenceTypes: ["Essence", "Électrique"],
      yesNo: ["oui", "non"],
    },
    title: "Calculateur",
    sendToRepresentative: "Envoi au représentant",
    steps: [
      "Select irrigation area",
      "Define your irrigation system",
      "Command your irrigation plan",
    ],
  },
  orderform: {
    billingAddress: "Addresse de facturation",
    client: {
      name: "Nom",
      address: "Addresse",
      city: "Ville",
      province: "Province",
      zipCode: "Code postal",
      phone: "Numéro de téléphone",
      email: "Courriel",
    },
    submit: "Soumettre",
    question: `Est-ce-que l'addresse de la commande est la même que l'adresse de la zone d'irrigation?`,
  },
  orderConfirmation: {
    title: "Voici nos recommandations",
    action: `Communiquer avec un représentant`,
    input: `exemple@email.com`,
    fail: `Echec d'envoi de courriel`,
  },
  orderModal: {
    btnCancel: `Annuler`,
    btnSend: `Envoyer`,
    text:
      "Un courriel comprenant les détails de votre commande vous sera envoyé sous peu.",
    title: "Confirmer votre courriel",
    emailSendWithSucces: "Courriel envoyé avec succès",
    succes: `Envoi de courriel avec succes`,
    fail: `Echec d'envoi de courriel`,
  },
  checkout: {
    title: "Checkout",
  },
};
